import { CommentsSVG } from "./SVGIllustrations";
import { classifyGlobal, getMotivationalPhrase } from "./helpers";

export default function Step4Comments({
  comentario1, onComentario1Change,
  comentario2, onComentario2Change,
  globalScore,
}) {
  const globalCls = classifyGlobal(globalScore);
  const phrase = getMotivationalPhrase(globalCls.key);

  return (
    <div>
      <CommentsSVG />

      <div className="mt-3 mb-4">
        <label className="block text-xs font-semibold mb-1.5" style={{ color: "#2D2A24" }}>
          ¿Qué necesitas hoy para sentirte un poco mejor?
        </label>
        <textarea
          value={comentario1}
          onChange={(e) => onComentario1Change(e.target.value)}
          placeholder="Puede ser algo pequeño o grande..."
          data-testid="f5-comentario1"
          className="we-input w-full"
          style={{ minHeight: 70, resize: "vertical" }}
        />
      </div>

      <div className="mb-5">
        <label className="block text-xs font-semibold mb-1.5" style={{ color: "#2D2A24" }}>
          ¿Hay algo más que quieras compartir sobre cómo te estás sintiendo?
        </label>
        <textarea
          value={comentario2}
          onChange={(e) => onComentario2Change(e.target.value)}
          placeholder="Este es un espacio seguro para ti..."
          data-testid="f5-comentario2"
          className="we-input w-full"
          style={{ minHeight: 70, resize: "vertical" }}
        />
      </div>

      {/* Hero global score */}
      <div
        className="rounded-2xl p-5 text-center"
        style={{
          background: "linear-gradient(135deg, #883476 0%, #A04890 50%, #C070A0 100%)",
          boxShadow: "0 8px 30px rgba(136,52,118,0.25)",
        }}
        data-testid="f5-global-score-hero"
      >
        <p className="text-xs font-semibold uppercase tracking-wide mb-1" style={{ color: "rgba(255,255,255,0.7)" }}>
          Score Emocional Global
        </p>
        <div className="text-5xl font-extrabold text-white mb-1" data-testid="f5-global-score-value">
          {globalScore}
        </div>
        <p className="text-xs font-bold text-white mb-2" style={{ opacity: 0.8 }}>de 100</p>
        <span
          className="inline-block text-xs font-bold px-3 py-1 rounded-lg mb-3"
          style={{ background: "rgba(255,255,255,0.2)", color: "white" }}
          data-testid="f5-global-score-category"
        >
          {globalCls.label}
        </span>
        <p className="text-xs leading-relaxed" style={{ color: "rgba(255,255,255,0.9)" }} data-testid="f5-motivational-phrase">
          {phrase}
        </p>
      </div>
    </div>
  );
}
